import React, { createContext, useContext, useState, useEffect } from "react";
import moment from "moment-timezone";

interface TimezoneContextProps {
  timezone: string;
  setTimezone: (tz: string) => void;
}

const TimezoneContext = createContext<TimezoneContextProps>({
  timezone: "UTC",
  setTimezone: () => {},
});

export const TimezoneProvider: React.FC<React.PropsWithChildren<{}>> = ({
  children,
}) => {
  const initialTimezone = localStorage.getItem("userTimezone") || "UTC";
  const [timezone, setTimezone] = useState(initialTimezone);

  useEffect(() => {
    localStorage.setItem("userTimezone", timezone);
    moment.tz.setDefault(timezone);
  }, [timezone]);

  return (
    <TimezoneContext.Provider value={{ timezone, setTimezone }}>
      {children}
    </TimezoneContext.Provider>
  );
};

export const useTimezone = () => useContext(TimezoneContext);
